import * as constants from '../constants/map';

/** Map Actions */

/**
 * Sets the currently displayed renderer
 *
 * @export
 * @param {string} renderer The currently displayed renderer
 * @returns
 */
export function setRenderer (renderer) {
    return {
        type: constants.SET_RENDERER,
        renderer
    }
}

/**
 * Sets the destination Waypoint for routing
 *
 * @export
 * @param {Waypoint} destination The intended destination
 * @returns {object}
 */
export function setDestination (destination) {
    return {
        type: constants.SET_DESTINATION,
        destination
    }
}

/**
 * Sets the origin Waypoint for routing and current position display
 *
 * @export
 * @param {Waypoint} origin The intended origin
 * @returns {object}
 */
export function setOrigin (origin) {
    return {
        type: constants.SET_ORIGIN,
        origin
    }
}

/**
 * Sets the selected POI
 *
 * @export
 * @param {POI} POI
 * @returns {object}
 */
export function setSelectedPOI (selectedPOI) {
    return {
        type: constants.SET_SELECTED_POI,
        selectedPOI
    }
}

/**
 * Sets the available map list
 *
 * @export
 * @param {Array<object>} maps
 * @returns {object}
 */
export function setAvailableMaps (maps) {
    return {
        type: constants.SET_AVAILABLE_MAPS,
        maps
    }
}

/**
 * Sets the selected map
 *
 * @export
 * @param {object} map
 * @returns {object}
 */
export function setSelectedMap (map) {
    return {
        type: constants.SET_SELECTED_MAP,
        map
    }
}



// WEBPACK FOOTER //
// ./src/actions/map.js